import type { ValueOf } from "@/shared/domain/types";

export const MUSCLE_ID = {
  chest: "chest",
  back: "back",
  traps: "traps",
  shoulders: "shoulders",
  biceps: "biceps",
  triceps: "triceps",
  forearms: "forearms",
  abs: "abs",
  obliques: "obliques",
  glutes: "glutes",
  quads: "quads",
  hamstrings: "hamstrings",
  calves: "calves",
} as const;

export type MuscleId = ValueOf<typeof MUSCLE_ID>;

type MuscleInfo = Readonly<{ label: string; color: string }>;

export const MUSCLES: Readonly<Record<MuscleId, MuscleInfo>> = {
  chest: { label: "Chest (Pectorals)", color: "#ff3b6b" },
  back: { label: "Back (Lats)", color: "#ffae3b" },
  traps: { label: "Trapezius", color: "#ffd23b" },
  shoulders: { label: "Shoulders (Deltoids)", color: "#3bff8a" },
  biceps: { label: "Biceps", color: "#3bd1ff" },
  triceps: { label: "Triceps", color: "#3b6bff" },
  forearms: { label: "Forearms", color: "#8a3bff" },
  abs: { label: "Abs (Rectus)", color: "#ff3bd1" },
  obliques: { label: "Obliques", color: "#ff7a3b" },
  glutes: { label: "Glutes", color: "#d13bff" },
  quads: { label: "Quadriceps", color: "#3bffd1" },
  hamstrings: { label: "Hamstrings", color: "#ffce3b" },
  calves: { label: "Calves", color: "#3bffae" },
};

export const ALL_MUSCLE_IDS: ReadonlyArray<MuscleId> = Object.values(MUSCLE_ID);

export const isMuscleId = (value: string): value is MuscleId => Object.hasOwn(MUSCLE_ID, value);
